import { apiClient } from "@slumbr/core";

import type { CallTokenProvider } from "@slumbr/calling-core";

/**
 * Production CallTokenProvider — same shape as @slumbr/calling-native's,
 * just routed through the web app's apiClient. Mints rooms + access
 * tokens server-side because `@huddle01/server-sdk` refuses to run in
 * browser bundles AND minting client-side would leak signing secrets.
 *
 * DEV_AUTH_BYPASS mocks live in apps/web — keeping them out of this
 * package means desktop builds always hit the real backend (no
 * accidental dev mocks shipped to packaged Electron apps).
 */
export const webCallTokenProvider: CallTokenProvider = {
  async createRoom({ title, conversationId }) {
    const body: Record<string, string> = { title };
    if (conversationId) body.conversationId = conversationId;
    const response = await apiClient.post<{ roomId: string }>(
      "/api/calls/rooms",
      body
    );
    return response.roomId;
  },

  async mintAccessToken({ roomId, identity }) {
    const response = await apiClient.post<{ token: string }>(
      "/api/calls/token",
      { roomId, displayName: identity.displayName }
    );
    return response.token;
  },

  async sendInvite(input) {
    await apiClient.post("/api/calls/invite", input);
  },
};
